export const spacePalette = (tokens) => {
    return {
        container: {
            default: tokens.aliasesSpaceContainerDefault,
            dense: tokens.aliasesSpaceContainerDense,
            spacious: tokens.aliasesSpaceContainerSpacious
        },
        component: {
            default: tokens.aliasesSpaceComponentDefault,
            dense: tokens.aliasesSpaceComponentDense,
            spacious: tokens.aliasesSpaceComponentSpacious,
            particle: tokens.aliasesSpaceComponentParticle
        }
    };
};
export default spacePalette;
//# sourceMappingURL=space.js.map